export default "__VITE_PUBLIC_ASSET__c0a79d43__"